import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactInformationForm } from './components';

const ContactInformationView = ({ button }) => {
  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  return (
    <>
      <h3>{t('contactInformation.header')}</h3>
      <ContactInformationForm button={button} />
    </>
  );
};

export default ContactInformationView;
